<template>
    <button :class="!disabled ? 'button' : 'button-disabled'" :style="`width: ${width}; height: ${height};`" @click="onSubmit" v-if="!outline" :title="title">
        <span v-if="icon" :style="`margin-right: 10px; font-weight: ${bold ? 'bold': ''}`">{{ icon }}</span>
        {{ name }}
      </button>
      <button v-else :class="!disabled ? 'button-outline' : 'button-disabled-outline'" :style="`width: ${width}; height: ${height};`" @click="onSubmit" :title="title">
        <span v-if="icon" :style="`margin-right: 10px; font-weight: ${bold ? 'bold': ''}`">{{ icon }}</span>
        {{ name }}
      </button>
</template>

<script>
export default {
    name: "ButtonComponent",
    props: {
        icon: {
            type: [String, HTMLElement]
        },
        name: {
            type: String,
            default: ""
        },
        width: {
            type: String,
            default: "150px"
        },
        height: {
            type: String,
            default: "45px"
        },
        param: {
            type: [String, Number]
        },
        outline: {
          type: Boolean,
          default: false
        },
        bold: {
          type: Boolean,
          default: false
        },
        title: {
          type: String
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
      onSubmit() {
        if (this.disabled) return
        this.$emit('click', this.param)
      }
    }
}
</script>

<style scoped>
.button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  font-weight: 400 !important;
  cursor: pointer;
  font-size: 17px;
  color: white;
  background-color: #162ca2;
}
.button:hover {
  background-color: #f1f6ff;
  color: black;
}
.button:active {
  color: #162ca2;
}
.button-disabled {
  background-color: #ACAFBF !important;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  border-radius: 12px;
  font-weight: 400 !important;
  cursor: pointer;
  font-size: 17px;
  color: white;
}

.button-outline {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  font-weight: 400 !important;
  cursor: pointer;
  color: #7B7E8C;
  font-size: 17px;
  border: 1px solid #7B7E8C;
}
.button-outline:hover {
  border: 1px solid #162CA2;
}
.button-outline:active {
  color: #162ca2;
  border: 1px solid #162CA2;
}
.button-outline-disabled {
  border: 1px solid #D3D6E1;
  color: #ACAFBF;
}
</style>